import { AppStateService } from 'src/app/core/services/app-state.service';
import { CreateNotificationSeenCommand } from './../../../../../core/api/models/create-notification-seen-command';
import { NotificationsService } from './../../../../../core/api/services/notifications.service';

import { CommonModule } from '@angular/common';
import { Component, inject, input, output } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { finalize, Subscription } from 'rxjs';
import { SharePipesModule } from 'src/app/core/pipes/pipes.module';
import { NotificationTypes } from '../../../../../core/api/models/notification-types';
import { DynamicTabService } from '../../../../../core/services/dynamic-tab.service';
import { BaseComponentComponent } from '../../../../../shared/components/base/base-component/base-component.component';
import { NotificationsBackgroundDirective } from '../notifications-bg.directive';
import { NotificationsIconDirective } from '../notifications-icon.directive';
import { NotificationImportanceLevelTextColorDirective } from '../notifications-importance-level.directive';
import { NotificationsListDto } from './../../../../../core/api/models/notifications-list-dto';

@Component({
    selector: 'notification-item',
    imports: [
        CommonModule,
        TranslateModule,
        SharePipesModule,
        MatTooltipModule,
        InlineSVGModule,
        NotificationsBackgroundDirective,
        NotificationsIconDirective,
    ],
    templateUrl: './notification-item.component.html'
})
export class NotificationItemComponent extends BaseComponentComponent {
  //#region props
  appStateService = inject(AppStateService);
  notification = input<NotificationsListDto>();
  notificationsService = inject(NotificationsService);
  dynamicTabService = inject(DynamicTabService);
  updateNotifications = output<any>();
  subscription: Subscription;
  get NotificationTypes() {
    return NotificationTypes;
  }
  //#endregion

  notificationSeenApi(notificationId?) {
    if (notificationId == 0) return;
    if (this.subscription) this.subscription.unsubscribe();

    this.loading = true;

    let body: CreateNotificationSeenCommand = {};
    if (notificationId) body.notificationId = notificationId;

    this.subscription = this.notificationsService
      .notificationsCreateNotificationSeen({ body })
      .pipe(
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe((res) => {
        if (res.isSucceed) this.updateNotifications.emit(res);
      });
  }

  onShowDetailNotificationToggle(element, event?: any) {
    if (
      (event.currentTarget as HTMLElement).classList.contains(
        'notification-msg'
      ) ||
      (event.currentTarget as HTMLElement).classList.contains(
        'notification-toggle-icon'
      )
    )
      this.changeNotificationDisplayMode(element as HTMLElement);
  }

  openTab(tabName) {
    this.dynamicTabService.setNewTab('');
    this.dynamicTabService.setNewTab(tabName);
    this.dynamicTabService.setActiveTab(tabName);
  }

  changeNotificationDisplayMode(event: HTMLElement) {
    // show detail
    const notificationMsgElement = event.querySelector('.notification-msg');
    if (notificationMsgElement) {
      notificationMsgElement.classList.toggle('max-two-row');
      notificationMsgElement.classList.toggle('h-[16px]');
    }
    //change toggle class icon
    const notificationToggleIconElement = event.querySelector(
      '.notification-toggle-icon'
    );
    if (!notificationToggleIconElement) return;
    if (notificationToggleIconElement.classList.contains('mdi-chevron-down')) {
      notificationToggleIconElement.classList.remove('mdi-chevron-down');
      notificationToggleIconElement.classList.add('mdi-chevron-up');
    } else if (
      notificationToggleIconElement.classList.contains('mdi-chevron-up')
    ) {
      notificationToggleIconElement.classList.remove('mdi-chevron-up');
      notificationToggleIconElement.classList.add('mdi-chevron-down');
    }
  }

  ngOnDestroy() {
    if (this.subscription) this.subscription.unsubscribe();
  }
}
